// extracted by mini-css-extract-plugin
module.exports = {"subNavigationItem":"subNavigation_subNavigationItem__KdRBd","onDark":"subNavigation_onDark__EivFm"};